import {ReactionType} from "../models/video";

export const NEW_LINE = "\n";
export const PERIOD_LIST = [1970, 1980, 1990, 2000, 2010, 2020, 2030];
export const REACTION_TYPES: ReactionType[] = ["LIKE", "CHEERS", "SURPRISED"];
export const LANGUAGE_JP = "ja";
export const LANGUAGE_ENG = "en";

// 言語リスト
export const LANGUAGE_OPTIONS = [
    { label: "中文 (简体)", value: "zh" },
    { label: "日本語", value: "ja" },
    { label: "English", value: "en" }
  ];